export default {"src":"/_next/static/media/search.f43cfd54.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};